export class ServiceTemplateMapping {
  serviceTempId: number;
  clientId: number;
  serviceHeaderId: number;
  templateId: number;
  serviceName: string;
  templateName: string;
  isActive: string | 'YES' | 'NO';

   constructor(init?: Partial<ServiceTemplateMapping>) {
    Object.assign(this, init);
  }
}